import { useEffect, useState } from 'react';
import Highcharts from 'highcharts';

export const useTransformAdditionalMetrixComparisonChartData = (
  options,
  selectedMetrix,
  data = {},
  selectedMetrixLabel
) => {
  const [chartOption, setChartOption] = useState({});

  useEffect(() => {
    const isPercentage = selectedMetrix === 'percentage';
    const seriesData = isPercentage ? [data?.yes_percentage, data?.no_percentage] : [data?.yes_count, data?.no_count];

    const extraConfig = {
      tooltip: {
        useHTML: true,
        outside: true,
        backgroundColor: 'transparent',
        borderWidth: 0,
        shadow: false,
        padding: 0,
        positioner: function (labelWidth, labelHeight, point) {
          const chart = this.chart;
          return {
            x: chart.plotLeft + chart.plotWidth / 2 - labelWidth / 2,
            y: point.plotY + chart.plotTop - labelHeight - 12
          };
        },

        formatter: function () {
          const value = Highcharts.numberFormat(this.y, 2);
          return `
      <div style="
        background: #1e222c;
        color: #fff;
        padding: 12px 18px;
        border-radius: 14px;
        font-size: 14px;
        box-shadow: 0 4px 14px rgba(0,0,0,0.25);
        display: flex;
        flex-direction: column;
        gap: 6px;
        pointer-events: none;
      ">
        <div style="font-size: 14px; font-weight: 600;">${this.key}</div>

        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center; gap: 6px;">
            <div style="
              width: 10px; height: 10px;
              background: ${this.color};
            "></div>
            <span style="opacity: 0.8;">${selectedMetrixLabel}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </div>
          <span style="font-weight: 600;">${value}${isPercentage ? '%' : ''}</span>
        </div>
      </div>
      <div style="
        width: 0; height: 0; margin: 0 auto;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 12px solid #1e222c;
      "></div>
    `;
        }
      },
      chart: {
        height: 300
      },
      plotOptions: {
        bar: {
          pointPadding: 0.2,
          groupPadding: 0.01
        },
        series: {
          point: {
            events: {
              click: function () {
                console.log('Bar clicked:', this);
              }
            }
          },
          cursor: 'pointer',
          events: {
            mouseOut() {
              this.chart.tooltip.hide(0);
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function () {
              const value = this.y;
              const isPercentage = selectedMetrix === 'percentage';
              if (value == null) {
                return isPercentage ? '0.00%' : '0.00';
              } else {
                return isPercentage ? value.toFixed(2) + '%' : value;
              }
            }
          }
        }
      },
      series: [{ ...options?.series?.[0], data: seriesData }],
      yAxis: {
        ...options?.yAxis,
        title: { ...options?.yAxis?.title, text: isPercentage ? 'Percentage %' : 'Sample Size' }
      }
    };
    const mergedOptions = Highcharts.merge(options, extraConfig);
    setChartOption(mergedOptions);
  }, [selectedMetrix]);

  return chartOption;
};
